// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  clerkUserId: __t.string().name("clerk_user_id"),
  email: __t.string(),
  firstName: __t.option(__t.string()).name("first_name"),
  lastName: __t.option(__t.string()).name("last_name"),
  avatarCdnPath: __t.option(__t.string()).name("avatar_cdn_path"),
  isWithcoEmployee: __t.bool().name("is_withco_employee"),
  brandIds: __t.array(__t.uuid()).name("brand_ids"),
  investorIds: __t.array(__t.uuid()).name("investor_ids"),
});
